import styled from 'styled-components';
import { StyledText } from '../../../styles/text';
import { colors, spacing } from '../../../styles/theme';
export const StyledContentHeading = styled(StyledText) `
  border-bottom: 1px solid ${colors.lightGrey};
  padding-bottom: ${spacing.base}px;
`;
//# sourceMappingURL=subcomponents.js.map